module.exports = __webpack_public_path__ + "media/images/nep-3fa9563b62b3c86f54508cec55254db2.png";